import { useMemo } from 'react';

import { useApiCrossVerticalSearchLinksRetrieve } from '@rover/rsdk/src/apiClient/latest/api-cross-vertical-search-links-retrieve';
import { useApiFrontendServiceTypesList } from '@rover/rsdk/src/apiClient/latest/api-frontend-service-types-list';
import type { SpecialtyServiceOptionsEnum } from '@rover/rsdk/src/apiClient/latest/model/specialtyServiceOptionsEnum';

import buildServiceSelectProps from './buildServiceSelectProps';
import type { ServiceSelectProps } from './ServiceSelect';

const useServiceSelectProps = (
  pageServiceTypeSlug: SpecialtyServiceOptionsEnum
): ServiceSelectProps | null => {
  const { data: serviceTypesData } = useApiFrontendServiceTypesList();
  const { data: crossVerticalSearchLinks } = useApiCrossVerticalSearchLinksRetrieve();

  return useMemo(() => {
    if (!crossVerticalSearchLinks?.isEnabled || !serviceTypesData) return null;

    return buildServiceSelectProps({
      pageServiceTypeSlug,
      serviceTypes: serviceTypesData.results,
      specialtyServiceOptions: crossVerticalSearchLinks.specialtyServiceOptions,
    });
  }, [crossVerticalSearchLinks, serviceTypesData, pageServiceTypeSlug]);
};

export default useServiceSelectProps;
